'use client';

import { PlayerSelectionView } from './PlayerSelectionView';
import { useOrderedSportsbooks } from '@/hooks/useOrderedSportsbooks';

/**
 * Client island for the NBA/MLB odds pages. Kept separate so the page shells can be
 * Server Components that export `metadata` (required for SEO canonical — plan §7/§10e).
 */
export function OddsPageClient() {
  const { sportsbooksOrder, handleReorderSportsbooks } = useOrderedSportsbooks();
  return (
    <PlayerSelectionView
      className="h-full"
      sportsbooks={sportsbooksOrder}
      onReorderSportsbooks={handleReorderSportsbooks}
    />
  );
}
